import useDictionary from '../../../../hooks/use-dictionary/useDictionary'
import Colors from '../../../../tokens/Colors'
import {
  fullwidthGridColumn,
  grid,
  gridColumnsDesktop,
} from '../../../../utils/grid'
import React, { Fragment, FunctionComponent } from 'react'
import { mediaQueries } from '../../../../utils/mediaQueries'
import { rem } from '../../../../utils/rem'
import Title from '../../../atoms/title/Title'
import Talks, { Talk, TalksProps } from '../../../molecules/talks/Talks'
import { SectionProps } from '../Sections'
import styled from 'styled-components'
import { isAfter, isBefore, parseISO } from 'date-fns'

export interface TalksSectionProps extends TalksProps, SectionProps {}

const TalksSection: FunctionComponent<TalksSectionProps> = ({
  className,
  talks = [],
}) => {
  const dictionary = useDictionary()

  /**
   * Sort talk by date
   */
  const sortByDate = (a: Talk, b: Talk): number => {
    const keyA = parseISO(a.date),
      keyB = parseISO(b.date)
    if (isBefore(keyA, keyB)) return -1
    if (isAfter(keyA, keyB)) return 1
    return 0
  }

  const upcomingTalks = talks
    .filter(({ date }) => isAfter(parseISO(date), new Date()))
    .sort((a: Talk, b: Talk) => sortByDate(a, b))

  const previousTalks = talks
    .filter(({ date }) => isBefore(parseISO(date), new Date()))
    .sort((a: Talk, b: Talk) => sortByDate(b, a))

  return (
    <div className={className}>
      {upcomingTalks.length && (
        <Fragment>
          <TitleWrapper withoutTopPadding={true}>
            <StyledTitle>{dictionary.get('upcomingTalks')}</StyledTitle>
          </TitleWrapper>
          <Talks talks={upcomingTalks} />
        </Fragment>
      )}
      {previousTalks.length && (
        <Fragment>
          <TitleWrapper withBorder={true}>
            <StyledTitle>{dictionary.get('previousTalks')}</StyledTitle>
          </TitleWrapper>
          <Talks talks={previousTalks} />
        </Fragment>
      )}
    </div>
  )
}

const StyledTitle = styled(Title)`
  ${fullwidthGridColumn()};

  ${mediaQueries.desktop} {
    grid-column: 2 / span ${gridColumnsDesktop};
  }
`

const TitleWrapper = styled.div<{
  withBorder?: boolean
  withoutTopPadding?: boolean
}>`
  ${grid()};
  padding-bottom: ${rem(100)};
  padding-top: ${({ withoutTopPadding }): string =>
    withoutTopPadding ? '0' : rem(100)};
  border-top: ${({ withBorder }): string =>
    withBorder ? `1px solid ${Colors.ALTO}` : 'none'};
`

export default TalksSection
